import React from 'react';
import ReactDOM from 'react-dom';
import { MemoryRouter } from 'react-router'
import './index.css';
import App from './App';
import { I18nextProvider } from "react-i18next";
import i18n from "./config/i18n";
import ls from "local-storage";

var hosturl = window.location.protocol +"//" + window.location.hostname;
var hosturl = "https://kabadate.com"
localStorage.setItem('api_url',hosturl+"/api/");  
localStorage.setItem('web_url',hosturl+"/web/");

// localStorage.setItem('api_url',"https://appservices.hitasoft.in/kabadate/api/");  
// localStorage.setItem('web_url',"https://appservices.hitasoft.in/kabadate/web/"); 


ReactDOM.render(
  <I18nextProvider i18n={i18n}>
    <MemoryRouter>
      <App />
    </MemoryRouter>
  </I18nextProvider>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
